import formatSeconds from '../format-seconds';

export const formatDuration = (duration: number) => {
  const { hours, minutes } = formatSeconds(duration);

  if (hours === 1 && minutes === 0) {
    return '1 t.';
  }

  return hours < 1 ? `${minutes} min.` : `${hours} t.${minutes > 0 ? ` ${minutes} min.` : ''}`;
};

export default formatDuration;
